import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import { Typography, Grid } from '@material-ui/core';
import { EnumOpcoesDelivery } from 'storage';
import { useStyles } from './opcoes-delivery-styles';
import { EmpresaModel } from 'api/cardapio/models/empresa/empresa-model';
import classNames from 'classnames';
import { enderecoFormatado } from 'utils/endereco-formatado';
import { useDadosDeliveryStore } from 'services/store/dados-delivery';
import { usePessoaUsuarioStore } from 'services/store/pessoa-usuario';
import { usePedidos } from 'services/providers/pedidos-provider';

export interface OpcoesDeliveryProps {
  empresa: EmpresaModel | undefined;
  permiteEntrega?: boolean;
  permiteRetirada?: boolean;
  quandoClicar: (abertoSacola?: boolean) => void;
}
export const OpcoesDelivery = ({
  empresa,
  permiteEntrega,
  permiteRetirada,
  quandoClicar,
}: OpcoesDeliveryProps) => {
  const classes = useStyles();
  const { enderecoDelivery, tipoDelivery, dadosWhatsapp } = useDadosDeliveryStore((state) => state);
  const { pessoa } = usePessoaUsuarioStore()
  const { cliente } = usePedidos()

  if ((permiteEntrega === false && permiteRetirada === false) && tipoDelivery === undefined) {
    return <></>;
  }
  return (
    <>
      {tipoDelivery !== undefined && (
        <>
          <Grid onClick={() => quandoClicar(true)} className={classes.root}>
            <Grid container justify="space-between">
              <Typography variant="body1" className={classNames(classes.colorSacola, classes.titulo)}>
                Dados do Pedido - {' '}
                {tipoDelivery === EnumOpcoesDelivery.Entrega
                  ? 'Entrega'
                  : 'Retirada no Local'}
              </Typography>
              <EditIcon className={classes.icon} />
            </Grid>
            <Typography variant="caption" color="textPrimary" className={classNames(classes.colorSacola, classes.endereco)}>
              {tipoDelivery === EnumOpcoesDelivery.Entrega
                ? (
                  (
                    enderecoDelivery?.logradouro &&
                    enderecoDelivery?.numero &&
                    enderecoDelivery?.bairro &&
                    enderecoDelivery?.xMun &&
                    enderecoDelivery?.uf
                  ) ?
                    enderecoFormatado(
                      enderecoDelivery?.logradouro || '',
                      enderecoDelivery?.numero || '',
                      enderecoDelivery?.bairro || '',
                      enderecoDelivery?.xMun || '',
                      enderecoDelivery?.uf || '',
                      enderecoDelivery?.complemento || '',
                      '',
                      enderecoDelivery?.referencia || '',
                    ) : ''
                )
                : enderecoFormatado(
                  empresa?.logradouro || '',
                  empresa?.numero || '',
                  empresa?.bairro || '',
                  empresa?.municipio || '',
                  empresa?.uf || '',
                )}
            </Typography>

            {tipoDelivery === EnumOpcoesDelivery.Retirada && (
              <Typography variant="body1" className={classes.colorSacola}>
                <strong>Pessoa a retirar:</strong> {pessoa?.nome || cliente?.nome || dadosWhatsapp?.nome || ''}
              </Typography>
            )}
          </Grid>
        </>
      )}
    </>
  );
};
